module.exports = __webpack_public_path__ + "static/media/icon_arrow_dark.bde9d6b0.svg";